var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrightedgecertified(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "258px",
    height: "90px",
    viewBox: "0 0 258 90",
    enableBackground: "new 0 0 258 90",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#E55D25",
    points: "11.163,40.549 4.118,66.85 10.314,64.75 14.635,69.656 21.68,43.373  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#E55D25",
    points: "23.412,40.549 30.458,66.85 24.264,64.75 19.939,69.656 12.899,43.373  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E35D25",
    stroke: "#FFFFFF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    d: "M19.843,70.061l-7.186-26.824 l10.895-2.927l7.19,26.844l-6.418-2.174L19.843,70.061z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#E55D25",
    points: "17.637,22.186 21.842,19.481 24.153,23.936 29.146,23.705 28.915,28.701 33.37,31.007  30.668,35.217 33.37,39.443 28.915,41.748 29.146,46.743 24.153,46.514 21.842,50.969 17.637,48.264 13.415,50.969  11.122,46.514 6.109,46.743 6.343,41.748 1.887,39.443 4.586,35.217 1.887,31.007 6.343,28.701 6.109,23.705 11.122,23.936  13.415,19.481  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E35D25",
    stroke: "#FFFFFF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    d: "M21.918,51.252l-4.281-2.754l-4.301,2.754 l-2.331-4.535l-5.103,0.234l0.241-5.086l-4.538-2.348l2.746-4.301l-2.748-4.286l4.54-2.347l-0.241-5.086l5.103,0.236 l2.331-4.534l4.301,2.753l4.281-2.753l2.353,4.534l5.081-0.236l-0.234,5.086l4.535,2.347l-2.75,4.286l2.75,4.301l-4.535,2.348 l0.234,5.086l-5.081-0.234L21.918,51.252z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E55D25",
    d: "M43.599,50.342V19.685h11.394c4.889,0,8.929,1.399,8.929,7.938c0,3.524-1.743,6.071-5.229,6.752v0.084 c4.55,0.637,5.737,3.565,5.737,7.771c0,7.772-6.76,8.112-9.48,8.112H43.599z M50.015,32.209h4.297 c1.403,0,3.358-0.935,3.358-3.906c0-2.25-1.531-3.906-3.696-3.906h-3.959V32.209z M50.015,45.627h3.573 c1.361,0,4.424-0.043,4.424-4.33c0-2.719-1.021-4.373-4.254-4.373h-3.743V45.627z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E55D25",
    d: "M74.083,50.342h-6.422V19.685h11.862c4.379,0,7.186,2.802,7.186,8.022c0,3.908-1.532,6.838-5.697,7.518 v0.085c1.402,0.17,5.571,0.509,5.571,6.027c0,1.955,0.126,7.729,0.722,9.005h-6.293c-0.851-1.869-0.679-3.949-0.679-5.945 c0-3.653,0.338-6.752-4.593-6.752h-1.657V50.342z M74.083,32.931h2.847c2.551,0,3.272-2.549,3.272-4.502 c0-2.929-1.234-4.032-3.272-4.032h-2.847V32.931z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E55D25",
    d: "M89.727,50.342V19.685h6.42v30.657H89.727z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E55D25",
    d: "M113.875,29.109c0.044-2.844-0.423-5.349-3.822-5.349c-4,0-4,5.389-4,11.335 c0,9.598,0.938,11.297,4.594,11.297c1.062,0,2.21-0.255,3.188-0.596v-6.791h-3.484v-4.714h9.906v15.54 c-1.743,0.338-6.122,1.018-8.674,1.018c-10.801,0-12.035-4.457-12.035-16.094c0-7.727,0.384-15.582,10.886-15.582 c6.293,0,10.205,3.524,9.823,9.936H113.875z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E55D25",
    d: "M137.26,31.955V19.685h6.42v30.657h-6.42V36.667h-7.355v13.675h-6.422V19.685h6.422v12.271H137.26z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E55D25",
    d: "M167.531,19.685v5.095h-7.145v25.562h-6.42V24.779h-7.143v-5.095H167.531z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E55D25",
    d: "M171.355,50.342V19.685h16.75v4.712h-10.328v7.559h9.525v4.712h-9.525v8.96h10.672v4.715H171.355z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E55D25",
    d: "M191.891,19.685h10.715c8.418,0,9.994,5.603,9.994,15.157c0,4.714,0.719,15.5-10.248,15.5h-10.461 V19.685z M198.312,45.627h3.102c3.912,0,4.676-2.927,4.676-10.614c0-5.647,0-10.616-4.459-10.616h-3.318V45.627z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E55D25",
    d: "M230.07,29.109c0.045-2.844-0.424-5.349-3.828-5.349c-3.996,0-3.996,5.389-3.996,11.335 c0,9.598,0.938,11.297,4.594,11.297c1.062,0,2.213-0.255,3.188-0.596v-6.791h-3.486v-4.714h9.908v15.54 c-1.742,0.338-6.123,1.018-8.676,1.018c-10.799,0-12.031-4.457-12.031-16.094c0-7.727,0.381-15.582,10.883-15.582 c6.293,0,10.207,3.524,9.824,9.936H230.07z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E55D25",
    d: "M240.314,50.342V19.685h16.754v4.712H246.74v7.559h9.521v4.712h-9.521v8.96h10.668v4.715H240.314z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E55D25",
    d: "M48.218,63.149c-0.137-1.003-1.003-1.413-1.938-1.413c-2.109,0-2.749,1.918-2.749,3.604 c0,1.688,0.64,3.603,2.749,3.603c0.913,0,1.824-0.457,2.029-1.484h0.797c-0.238,1.382-1.504,2.168-2.826,2.168 c-2.497,0-3.546-2.009-3.546-4.286c0-2.259,1.06-4.288,3.546-4.288c1.345,0,2.623,0.616,2.735,2.097H48.218z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E55D25",
    d: "M54.231,69.455v-8.23h4.891v0.684h-4.153v2.953h3.993v0.684h-3.993v3.227h4.323v0.684H54.231z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E55D25",
    d: "M65.372,69.455H64.63v-8.23h2.69c0.719,0,1.312,0.045,1.938,0.432c0.569,0.344,0.844,0.936,0.844,1.723 c0,0.889-0.627,1.527-1.583,1.768v0.022c1.049,0.172,1.274,0.878,1.38,1.835c0.147,1.333,0.101,1.949,0.433,2.451h-0.856 c-0.194-0.547-0.241-1.129-0.286-1.708c-0.168-1.882-0.283-2.214-1.776-2.214h-2.041V69.455z M66.958,64.85 c1.047,0,2.347-0.07,2.347-1.471c0-1.584-1.482-1.471-2.269-1.471h-1.665v2.941H66.958z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E55D25",
    d: "M77.071,61.908h-2.656v-0.684h6.02v0.684h-2.609l-0.013,7.547h-0.729L77.071,61.908z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E55D25",
    d: "M85.24,69.455v-8.266h0.741v8.266H85.24z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E55D25",
    d: "M91.693,69.455v-8.23h4.65v0.684h-3.909v2.906h3.774v0.684h-3.774v3.957H91.693z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E55D25",
    d: "M101.592,69.455v-8.266h0.741v8.266H101.592z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E55D25",
    d: "M108.126,69.455v-8.23h4.893v0.684h-4.151v2.953h3.991v0.684h-3.991v3.227h4.319v0.684H108.126z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E55D25",
    d: "M120.615,61.225c2.703,0,4.241,1.391,4.241,4.116c0,2.724-1.538,4.114-4.241,4.114h-2.225v-8.23 H120.615z M120.796,68.771c2.316,0,3.261-1.358,3.261-3.431c0-2.429-1.424-3.5-3.762-3.433h-1.162v6.863H120.796z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E55D25",
    d: "M136.742,69.455v-8.23h2.062c1.584-0.035,3.363,0.362,3.363,2.324s-1.779,2.361-3.363,2.328h-1.322 v3.578H136.742z M137.482,65.191h1.801c1.105,0,2.086-0.354,2.086-1.643c0-1.286-0.98-1.641-2.086-1.641h-1.801V65.191z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E55D25",
    d: "M147.906,69.455h-0.742v-8.23h2.691c0.719,0,1.311,0.045,1.938,0.432 c0.572,0.344,0.844,0.936,0.844,1.723c0,0.889-0.627,1.527-1.584,1.768v0.022c1.049,0.172,1.275,0.878,1.379,1.835 c0.146,1.333,0.105,1.949,0.434,2.451h-0.855c-0.191-0.547-0.238-1.129-0.285-1.708c-0.17-1.882-0.281-2.214-1.779-2.214 h-2.039V69.455z M149.49,64.85c1.049,0,2.35-0.07,2.35-1.471c0-1.584-1.482-1.471-2.27-1.471h-1.664v2.941H149.49z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E55D25",
    d: "M161.227,69.627c-2.361,0-3.672-1.723-3.672-4.286c0-2.566,1.311-4.288,3.672-4.288 c2.359,0,3.67,1.722,3.67,4.288C164.896,67.904,163.586,69.627,161.227,69.627z M161.227,68.943 c2.051,0,2.873-1.801,2.873-3.603c0-1.804-0.822-3.604-2.873-3.604c-2.055,0-2.875,1.801-2.875,3.604 C158.352,67.143,159.172,68.943,161.227,68.943z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E55D25",
    d: "M170.168,69.455v-8.23h4.65v0.684h-3.906v2.906h3.77v0.684h-3.77v3.957H170.168z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E55D25",
    d: "M180.012,69.455v-8.23h4.889v0.684h-4.15v2.953h3.992v0.684h-3.992v3.227h4.32v0.684H180.012z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E55D25",
    d: "M192.35,69.627c-1.311,0-2.418-0.957-2.451-2.314h0.797c0.023,1.266,0.957,1.631,2.062,1.631 c0.926,0,1.984-0.537,1.984-1.586c0-0.82-0.592-1.21-1.285-1.436c-1.336-0.442-3.365-0.868-3.365-2.647 c0-1.434,1.322-2.222,2.623-2.222c1.082,0,2.496,0.376,2.68,1.961h-0.801c-0.021-1.014-0.945-1.277-1.789-1.277 c-0.855,0-1.914,0.434-1.914,1.438c0,2.337,4.648,1.277,4.648,4.118C195.539,69.08,194.002,69.627,192.35,69.627z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E55D25",
    d: "M202.74,69.627c-1.312,0-2.42-0.957-2.453-2.314h0.799c0.021,1.266,0.957,1.631,2.062,1.631 c0.922,0,1.984-0.537,1.984-1.586c0-0.82-0.594-1.21-1.289-1.436c-1.334-0.442-3.363-0.868-3.363-2.647 c0-1.434,1.322-2.222,2.623-2.222c1.084,0,2.498,0.376,2.678,1.961h-0.797c-0.023-1.014-0.945-1.277-1.789-1.277 c-0.855,0-1.916,0.434-1.916,1.438c0,2.337,4.65,1.277,4.65,4.118C205.93,69.08,204.391,69.627,202.74,69.627z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E55D25",
    d: "M211.234,69.455v-8.266h0.742v8.266H211.234z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E55D25",
    d: "M221.043,69.627c-2.361,0-3.672-1.723-3.672-4.286c0-2.566,1.311-4.288,3.672-4.288 c2.359,0,3.67,1.722,3.67,4.288C224.713,67.904,223.402,69.627,221.043,69.627z M221.043,68.943 c2.051,0,2.871-1.801,2.871-3.603c0-1.804-0.82-3.604-2.871-3.604c-2.053,0-2.875,1.801-2.875,3.604 C218.168,67.143,218.99,68.943,221.043,68.943z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E55D25",
    d: "M229.949,61.225h0.844l4.541,7.237h0.02v-7.237h0.74v8.23h-0.932l-4.447-7.113h-0.021v7.113h-0.744 V61.225z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E55D25",
    d: "M240.662,69.455l3.258-8.23h0.867l3.283,8.23h-0.811l-0.877-2.223h-4.094l-0.867,2.223H240.662z  M246.119,66.549l-1.777-4.641l-1.812,4.641H246.119z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E55D25",
    d: "M252.725,69.455v-8.23h0.74v7.547h4.139v0.684H252.725z"
  }))))), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M17.628,24.344c-5.891,0-10.667,4.776-10.667,10.667s4.776,10.667,10.667,10.667 s10.667-4.776,10.667-10.667S23.519,24.344,17.628,24.344z M17.628,42.122c-3.927,0-7.111-3.185-7.111-7.111 s3.185-7.111,7.111-7.111s7.111,3.185,7.111,7.111S21.555,42.122,17.628,42.122z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#E35D25",
    strokeMiterlimit: 10,
    x1: 17.628,
    y1: 34.91,
    x2: 17.626,
    y2: 23.375
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#E35D25",
    strokeMiterlimit: 10,
    x1: 17.628,
    y1: 34.91,
    x2: 6.961,
    y2: 31.443
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#E35D25",
    strokeMiterlimit: 10,
    x1: 17.626,
    y1: 34.908,
    x2: 29.903,
    y2: 30.919
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#E35D25",
    strokeMiterlimit: 10,
    x1: 17.628,
    y1: 34.928,
    x2: 10.345,
    y2: 44.944
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#E35D25",
    strokeMiterlimit: 10,
    x1: 17.628,
    y1: 34.928,
    x2: 24.512,
    y2: 44.111
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrightedgecertified);
export default __webpack_public_path__ + "static/media/brightedgecertified.c4a57df556cac743b1605ecd4b39a49f.svg";
export { ForwardRef as ReactComponent };